import Loader from "react-loader-spinner";
import { PencilSquare, DashCircle, PlusSquare, Trash, ExclamationTriangle } from 'react-bootstrap-icons';
import { Table, Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { getComplaintsMainGroupList, addEditComplaintMainGroup, deleteComplaintsMainGroup, getComplaintsSubGroup, addEditComplaintsSubGroup, deleteComplaintsSubGroup } from "../store/api/ComplaintsAPI";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faObjectGroup, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalAddEditComplaintsGroup = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const [mainEditMode, setMainEditMode] = useState(false);
    const [groupEditMode, setGroupEditMode] = useState(false);
    const notForSelect = useRef(false);
    const currentMainGroup = useRef({});
    const currentGroup = useRef({});
    const [error, setError] = useState(null);
    const [mainGroupList, setMainGroupList] = useState(null);
    const [groupList, setGroupList] = useState(null);

    const close = () => {
        setPopData({
            show: false
        })
        currentMainGroup.current = {};
        currentGroup.current = {};
        setGroupList(null);
    }
    const searchGroups = (mainG) => {
        const tr = mainG.event.target.closest(".resultTableRow");
        const modal = document.getElementById("modalAddEditComplaintsGroup");
        modal.querySelectorAll(".selectedResultTableRow").forEach(el => el.classList.remove("selectedResultTableRow"));
        if (tr) {
            tr.classList.add("selectedResultTableRow");
        }
        if (notForSelect.current) {
            notForSelect.current = false;
            return;
        }

        currentMainGroup.current = mainG.mainGroup;
        getComplaintsSubGroup(mainG.mainGroup.MainGroupID, setGroupList);
    }
    const addOrUpdateMainG = () => {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }
            if (mainEditMode) {
                setMainEditMode(false);
            }
            else {
                const frm = document.getElementById("frmMainGroup");
                frm.reset();
                getComplaintsMainGroupList(setMainGroupList);

            }
            currentMainGroup.current = {};
        }
        if (
            !currentMainGroup.current.MainGroupName ||
            currentMainGroup.current.MainGroupName === '') {
            return;
        }
        if (!mainEditMode) {
            currentMainGroup.current.MainGroupID = 0;
        }

        addEditComplaintMainGroup(currentMainGroup.current, onSuccess);
    }
    const addOrUpdatePG = () => {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }

            if (groupEditMode) {
                setGroupEditMode(false);
            }
            else {
                const frm = document.getElementById("frmGroup");
                frm.reset();
                getComplaintsSubGroup(currentMainGroup.current.MainGroupID, setGroupList);
            }
            currentGroup.current = {};
        }
        if (
            !currentGroup.current.GroupName ||
            currentGroup.current.GroupName === '') {
            return;
        }
        currentGroup.current.MainGroupID = currentMainGroup.current.MainGroupID;
        if (!groupEditMode) {
            currentGroup.current.GroupID = 0;
        }
        addEditComplaintsSubGroup(currentGroup.current, onSuccess);
    }
    const setMainToEditMode = (mainG) => {
        notForSelect.current = true;
        if (mainEditMode) {
            return;
        }
        currentMainGroup.current = mainG;
        setMainEditMode(true);
    }
    const setGroupToEditMode = (group) => {
        currentGroup.current = group;
        setGroupEditMode(true);
    }
    const cancelMainEditMode = () => {
        currentMainGroup.current = {};
        setMainEditMode(false);
    }
    const cancelEditMode = () => {
        currentGroup.current = {};
        setGroupEditMode(false);
    }
    const deleteGroup = (id) => {

        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                getComplaintsSubGroup(currentMainGroup.current.MainGroupID, setGroupList);
            }
        }
        deleteComplaintsSubGroup(id, onDelete);
    }
    const deleteMain = (id) => {
        notForSelect.current = true;
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                setGroupList(null);
                getComplaintsMainGroupList(setMainGroupList);
            }
        }
        deleteComplaintsMainGroup(id, onDelete);
    }
    useEffect(() => {
        if (show)
            getComplaintsMainGroupList(setMainGroupList);
    }, [show]);
    return (
        <Modal id="modalAddEditComplaintsGroup" show={show} size="lg" style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faObjectGroup} size="lg" style={{ marginLeft: "3px" }} /> مدیریت گروهبندی شکایات </span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error && <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {error} <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} /></Alert>}
                <Row>
                    <div className="col-md-6 scThin">
                        <p style={{ color: "black", margin: "0", fontWeight: "bold" }}>گروه های اصلی</p>
                        <hr style={{ margin: "5px", color: "blue", height: "2px" }} />
                        <input type="hidden" value={mainEditMode} readOnly />
                        <Table responsive className="fixedTable mt-2" id="tblMainGroups" style={{ whiteSpace: "nowrap" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "20%" }}>کد گروه</th>
                                    <th style={{ width: "60%" }}>نام گروه</th>
                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(mainGroupList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                            <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                        </td>
                                    </tr>
                                }
                                {Array.isArray(mainGroupList?.Data ?? "") &&
                                    mainGroupList.Data.map((item, i) =>
                                        <tr key={i} className="resultTableRow" onClick={(e) => searchGroups({ mainGroup: item, event: e })}>
                                            <td style={{ width: "20%" }}>{item.MainGroupCode}</td>
                                            <td style={{ width: "60%" }}>{item.MainGroupName}</td>
                                            <td style={{ width: "20%" }}>
                                                <PencilSquare className="rowBtn" color="#eb6e34" size={16} onClick={() => setMainToEditMode(item)} />
                                                &nbsp;
                                                <Trash className="rowBtn" color="red" size={16} onClick={() => deleteMain(item.MainGroupID)} />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                        {!mainEditMode &&
                            <form id="frmMainGroup">
                                <Row>
                                    <Col md={7} style={{ padding: "3px" }}>
                                        <input type="text" className="tableRowInput" placeholder="نام گروه" onChange={e => currentMainGroup.current.MainGroupName = e.target.value} />
                                    </Col>
                                    <Col md={1} style={{ padding: "2px" }}>
                                        <Button className="group-Btn-smalll" onClick={addOrUpdateMainG}><PlusSquare size={18} /></Button>
                                    </Col>
                                </Row>
                            </form>
                        }
                        {mainEditMode &&
                            <Row>
                                <Col md={3} style={{ padding: "3px", paddingRight: "10px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentMainGroup.current?.MainGroupCode ?? ""} readOnly />
                                </Col>
                                <Col md={6} style={{ padding: "3px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentMainGroup.current.MainGroupName ? currentMainGroup.current.MainGroupName : ""}
                                        onChange={e => currentMainGroup.current.MainGroupName = e.target.value} />
                                </Col>
                                <Col md={3} style={{ padding: "2px" }}>
                                    <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdateMainG}><PencilSquare size={18} /></Button>
                                    <Button variant="danger" className="group-Btn-smalll" onClick={cancelMainEditMode}><DashCircle size={18} /></Button>
                                </Col>
                            </Row>
                        }
                    </div>
                    <Col md={6} className="scThin">
                        <p style={{ color: "black", margin: "0", fontWeight: "bold" }}>{'گروه های فرعی ' + (!mainEditMode && currentMainGroup.current.MainGroupName ? '[ ' + currentMainGroup.current.MainGroupName + ' ]' : '')}</p>
                        <hr style={{ margin: "5px", color: "blue", height: "2px" }} />
                        <Table responsive className="fixedTable mt-2" id="tblGroups" style={{ whiteSpace: "nowrap" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "20%" }}>کد گروه</th>
                                    <th style={{ width: "60%" }}>نام گروه</th>
                                    <th style={{ width: "20%" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(groupList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                            <Loader type="BallTriangle" color="#bb1370" height={20} width={20} />
                                        </td>
                                    </tr>
                                }
                                {Array.isArray(groupList?.Data ?? "") &&
                                    groupList.Data.map((item, i) =>
                                        <tr key={i} className="resultTableRow">
                                            <td style={{ width: "20%" }}>{item.GroupCode}</td>
                                            <td style={{ width: "60%" }}>{item.GroupName}</td>
                                            <td style={{ width: "20%" }}>
                                                <PencilSquare className="rowBtn" color="#eb6e34" size={16} onClick={() => setGroupToEditMode(item)} />
                                                &nbsp;
                                                <Trash className="rowBtn" color="red" size={16} onClick={() => deleteGroup(item.GroupID)} />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                        {!groupEditMode &&
                            <form id="frmGroup">
                                <div className="row">
                                    <div className="col-md-7" style={{ padding: "3px" }}>
                                        <input type="text" className="tableRowInput" placeholder="نام گروه" onChange={e => currentGroup.current.GroupName = e.target.value} />
                                    </div>
                                    <div className="col-md-1" style={{ padding: "2px" }}>
                                        <Button className="group-Btn-smalll" onClick={addOrUpdatePG}><PlusSquare size={18} /></Button>
                                    </div>
                                </div>
                            </form>
                        }
                        {groupEditMode &&
                            <div className="row">
                                <div className="col-md-3" style={{ padding: "3px", paddingRight: "10px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentGroup.current?.GroupCode ?? ""} readOnly />
                                </div>
                                <div className="col-md-6" style={{ padding: "3px" }}>
                                    <input type="text" className="tableRowInput" defaultValue={currentGroup.current?.GroupName ?? ""}
                                        onChange={e => currentGroup.current.GroupName = e.target.value} />
                                </div>
                                <div className="col-md-3" style={{ padding: "2px" }}>
                                    <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdatePG}><PencilSquare size={18} /></Button>
                                    <Button variant="danger" className="group-Btn-smalll" onClick={cancelEditMode}><DashCircle size={18} /></Button>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddEditComplaintsGroup;